"use client";

import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Parallax } from "swiper/modules";
import { SimpleCaseData } from "@/cms/models";
import "swiper/css";
import "swiper/css/navigation";
import Link from "next/link";
import RippleCtaButton from "./ui/RippleCtaButton";
interface CaseSliderProps {
  cases: SimpleCaseData[];
  title: string;
  placering: string;
}

const CaseSlider: React.FC<CaseSliderProps> = ({ cases, title, placering }) => {
  const sliderRef = useRef<any>(null);

  function getPlacement() {
    switch (placering) {
      case "Center":
        return "justify-center";
      case "Højre lodret":
        return "justify-end";
      case "Højre":
        return "justify-end";
      case "Venstre":
        return "justify-start";
    }
  }

  function getTextPlacement() {
    switch (placering) {
      case "Center":
        return "justify-center";
      case "Højre":
        return "justify-start";
      case "Venstre":
        return "justify-start";
      default:
        return "justify-center";
    }
  }

  return (
    <div
      ref={sliderRef}
      className="relative h-full overflow-hidden custom-slider"
    >
      <Swiper
        speed={600}
        navigation={true}
        modules={[Navigation, Parallax]}
        parallax={true}
      >
        {cases.map((x, index) => (
          <SwiperSlide className="relative" key={`${x.id}-${index}`}>
            {x.imageUrl && (
              <img
                data-swiper-parallax="-100"
                src={x.imageUrl}
                alt={x.imageUrl}
                className="object-cover w-full h-full"
              />
            )}
            <div
              data-swiper-parallax="-800"
              className={`hidden lg:flex absolute inset-0 max-w-screen-xl px-8 lg:px-0  mx-auto items-center ${getPlacement()}`}
            >
              <div className="relative w-full lg:w-1/2 p-6">
                <div className="absolute inset-0 z-20 bg-white opacity-80"></div>
                <div className="relative z-20 flex flex-col text-black justify-center items-center">
                  <div className="flex flex-col gap-4 flex-1 w-full">
                    <div className="flex flex-col gap-4 flex-1 w-full">
                      <div className={`flex flex-col gap-2`}>
                        <div
                          className={`homepage-text-xl flex ${getTextPlacement()}`}
                        >
                          {title}
                        </div>
                        <div
                          className={`homepage-text-sm flex ${getTextPlacement()}`}
                        >
                          {x.displayName}
                        </div>
                      </div>
                    </div>
                    <div className="hidden lg:flex justify-center">
                      <Link
                        aria-label="Se mere"
                        href={`/ejendom/${x.displayName.replace(" ", "-").toLowerCase()}-${x.location.replace(" ", "-").toLowerCase()}____${x.id}`}
                      >
                        <RippleCtaButton>Se mere</RippleCtaButton>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Link
              data-swiper-parallax="-100"
              href={`/ejendom/${x.displayName.replace(" ", "-").toLowerCase()}-${x.location.replace(" ", "-").toLowerCase()}____${x.id}`}
              className="lg:hidden p-4 absolute bottom-0 left-0 right-0 bg-white opacity-80 z-10"
            >
              <div className={`homepage-text-xl flex ${getTextPlacement()}`}>
                {title}
              </div>
              <div className={`homepage-text-sm flex ${getTextPlacement()}`}>
                {x.displayName}
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CaseSlider;
